import { fetchApi } from 'utils/request';

export const apiGetUserCreditBalance = ({
  sessionToken,
  userId,
}: {
  sessionToken?: string;
  userId: string;
}): Promise<CF.API.Users.IGetCreditBalance> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/credit_balance`,
    sessionToken,
    method: 'GET',
  });

export const apiRechargeUserCreditBalance = ({
  sessionToken,
  userId,
  body,
}: {
  sessionToken?: string;
  userId: string;
  body: Pick<CF.API.Users.IPostCreditBalance, 'credit_grants' | 'idempotency_key'>;
}): Promise<CF.API.Users.IPostCreditBalance> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/credits`,
    sessionToken,
    method: 'POST',
    body,
  });

export const apiListUserCreditGrants = ({
  sessionToken,
  userId,
}: {
  sessionToken?: string;
  userId: string;
}): Promise<CF.API.Users.IListUserCreditGrants> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/credit_grants`,
    sessionToken,
    method: 'GET',
  });

export const apiAddCreditAutoTopUpConfig = ({
  sessionToken,
  userId,
  topAmount,
  thresholdAmount,
}: {
  sessionToken?: string;
  userId: string;
  topAmount: number;
  thresholdAmount: number;
}): Promise<CF.API.Users.ICreditAutoTopUpConfig> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/credit_auto_top_up`,
    sessionToken,
    method: 'PUT',
    body: {
      credit_auto_top_up_config: {
        top_up_amount_cents: topAmount,
        threshold_amount_cents: thresholdAmount,
      },
    },
  });

export const apiGetCreditAutoTopUpConfig = ({
  sessionToken,
  userId,
}: {
  sessionToken?: string;
  userId: string;
}): Promise<CF.API.Users.ICreditAutoTopUpConfig> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/credit_auto_top_up`,
    sessionToken,
    method: 'GET',
  });

export const apiDeleteCreditAutoTopUpConfig = ({
  sessionToken,
  userId,
}: {
  sessionToken?: string;
  userId: string;
}): Promise<CF.API.Users.ICreditAutoTopUpConfig> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/credit_auto_top_up`,
    sessionToken,
    method: 'DELETE',
  });
